import type { ZeroHeightTheme } from './@bothrs-theme/types/zero-height-theme'

export const theme: ZeroHeightTheme = {
  Colors: {
    Background: {
      Dark: '#20216B',
      Light: '#f6f6f9',
      White: '#ffffff',
    },
    Category: {
      Appointment: '#02418e',
      AppointmentRequest: '#02418e',
      Knowledge: '#D06F47',
      Task: '#25AF94',
      Content: '#25AF94',
      Communication: '#D06F47',
      Brochure: '#D06F47',
      Message: '#009edf',
      Invoice: '#c59f93',
      Intake: '#9366f2',
      Remecare: '#F49911',
      Hylyght: '#4F51DA',
      Document: '#be7450',
    },
    Neutrals: {
      Dark: '#747d99',
      Darker: '#4e5670',
      Darkest: '#012249',
      Light: '#DDE0E8',
      Lighter: '#f8f8f8',
      Lightest: '#ffffff',
      50: '#f0f0f0',
      400: '#7D8CA8',
      500: '#5D6F92',
    },
    Status: {
      Disabled: '#d6d6d6',
      Error: '#b50c00',
      Success: '#37a933',
      Warning: '#d59c0c',
    },
    Theme: {
      Primary: '#033878',
      Secondary: '#93c5bb',
      Tertiary: '#ffffff',
    },
  },
  Components: {
    Button: {
      Primary: {
        ActiveBorder: 'rgba(0, 0, 0, 0)',
        ActiveFill: '#012856',
        ActiveText: '#ffffff',
        Border: 'rgba(0, 0, 0, 0)',
        DisabledBorder: 'rgba(0, 0, 0, 0)',
        DisabledFill: '#f0f0f2',
        DisabledText: '#acacbb',
        Fill: '#033878',
        Text: '#ffffff',
      },
      PrimaryWarning: {
        ActiveBorder: 'rgba(0, 0, 0, 0)',
        ActiveFill: '#940a00',
        ActiveText: '#ffffff',
        Border: 'rgba(0, 0, 0, 0)',
        DisabledBorder: 'rgba(0, 0, 0, 0)',
        DisabledFill: '#f0f0f2',
        DisabledText: '#acacbb',
        Fill: '#b50c00',
        Text: '#ffffff',
      },
      Secondary: {
        ActiveBorder: '#012856',
        ActiveFill: '#f4f5f8',
        ActiveText: '#012856',
        Border: '#364d96',
        DisabledBorder: '#f0f0f2',
        DisabledFill: '#ffffff',
        DisabledText: '#acacbb',
        Fill: '#ffffff',
        Text: '#033878',
      },
      SecondaryWarning: {
        ActiveBorder: '#940a00',
        ActiveFill: '#ffffff',
        ActiveText: '#940a00',
        Border: '#b50c00',
        DisabledBorder: '#e5e5ed',
        DisabledFill: '#ffffff',
        DisabledText: '#cbcbd5',
        Fill: '#ffffff',
        Text: '#b50c00',
      },
      Tertiary: {
        ActiveText: '#001a38',
        DisabledText: '#acacbb',
        Text: '#033878',
        ActiveBorder: 'rgba(255, 255, 255, 0)',
        ActiveFill: 'rgba(255, 255, 255, 0)',
        Border: 'rgba(255, 255, 255, 0)',
        DisabledBorder: 'rgba(255, 255, 255, 0)',
        DisabledFill: 'rgba(255, 255, 255, 0)',
        Fill: 'rgba(255, 255, 255, 0)',
      },
      TertiaryWarning: {
        ActiveText: '#940a00',
        DisabledText: '#acacbb',
        Text: '#b50c00',
        ActiveBorder: 'rgba(255, 255, 255, 0)',
        ActiveFill: 'rgba(255, 255, 255, 0)',
        Border: 'rgba(255, 255, 255, 0)',
        DisabledBorder: 'rgba(255, 255, 255, 0)',
        DisabledFill: 'rgba(255, 255, 255, 0)',
        Fill: 'rgba(255, 255, 255, 0)',
      },
      Grey: {
        ActiveText: '#012249',
        DisabledText: '#012249',
        Text: '#012249',
        ActiveBorder: '#EFF1F6',
        ActiveFill: '#EFF1F6',
        Border: '#EFF1F6',
        DisabledBorder: '#EFF1F6',
        DisabledFill: '#EFF1F6',
        Fill: '#EFF1F6',
      },
    },
    Card: {
      ActiveBorder: '#334069',
      ActiveFill: '#ffffff',
      Border: '#ebeef2',
      DisabledBorder: '#ebeef2',
      DisabledFill: '#ffffff',
      Fill: '#ffffff',
      ActiveText: '#012249',
      DisabledText: '#4e5670',
      Text: '#012249',
    },
    Chip: {
      Primary: {
        ActiveBorder: 'rgba(0, 0, 0, 0)',
        ActiveFill: '#030a20',
        ActiveText: '#ffffff',
        Border: 'rgba(0, 0, 0, 0)',
        Fill: '#eff1f6',
        Text: '#072832',
      },
      Secondary: {
        ActiveBorder: '#3a3f4e',
        ActiveFill: 'rgba(255, 255, 255, 0)',
        ActiveText: '#012249',
        Border: '#c3c7d4',
        Fill: 'rgba(255, 255, 255, 0)',
        Text: '#334069',
      },
      PrimaryWarning: {
        ActiveBorder: '#bf2b20',
        ActiveFill: '#bf2b20',
        ActiveText: '#ffffff',
        Border: '#bf2b20',
        Fill: '#ffffff',
        Text: '#bf2b20',
      },
      SecondaryWarning: {
        ActiveBorder: '#df8805',
        ActiveFill: '#ffffff',
        ActiveText: '#c17604',
        Border: '#f9d49c',
        Fill: '#ffffff',
        Text: '#df8805',
      },
      SecondarySuccess: {
        ActiveBorder: '#37a933',
        ActiveFill: 'rgba(255, 255, 255, 0)',
        ActiveText: '#168212',
        Border: '#b8dbb6',
        Fill: 'rgba(255, 255, 255, 0)',
        Text: '#168212',
      },
      AppUpdate: {
        ActiveBorder: '#3A3F4E',
        ActiveFill: 'rgba(255, 255, 255, 0)',
        ActiveText: '#012249',
        Border: '#3A3F4E',
        Text: '#012249',
        Fill: 'rgba(255, 255, 255, 0)',
      },
    },
    Conversational: {
      ActiveBorder: '#033878',
      ActiveFill: '#f6f6f9',
      ActiveText: '#033878',
      Border: '#dadce0',
      Fill: '#ffffff',
      Text: '#033878',
    },
    Input: {
      ActiveBorder: '#0f323c',
      ActiveFill: '#ffffff',
      Border: '#c3c7d4',
      DisabledBorder: '#d6d6d6',
      DisabledFill: '#ffffff',
      ErrorBorder: '#b50c00',
      ErrorFill: '#ffffff',
      ErrorText: '#b50c00',
      Fill: '#ffffff',
      Placeholder: '#8990a3',
      SuccessBorder: '#37a933',
      SuccessFill: '#ffffff',
      SuccessText: '#37a933',
      Text: '#012249',
      DisabledText: '#d6d6d6',
    },
    Modal: {
      Backdrop: 'rgba(12, 22, 56, 0.4)',
      Background: '#ffffff',
      Border: '#e6e6eb',
    },
    Navigation: {
      ActiveText: '#0f323c',
      DisabledText: '#f0f0f2',
      Text: '#9299ae',
    },
    Toaster: {
      Border: 'rgba(0, 0, 0, 0)',
      ErrorBorder: 'rgba(0, 0, 0, 0)',
      ErrorFill: '#bf2b20',
      ErrorText: '#ffffff',
      Fill: '#dee1ec',
      SuccessBorder: 'rgba(0, 0, 0, 0)',
      SuccessFill: '#50b44c',
      SuccessText: '#ffffff',
      Text: '#012249',
    },
  },
  Typography: {
    BodyExtraLargeRegular: {
      'font-family': 'DINOT',
      'font-size': '18px',
      'letter-spacing': '0px',
      'line-height': '28px',
      'font-weight': '400',
      display: 'inline-block',
    },
    BodyLargeBold: {
      'font-family': 'DINOT',
      'font-size': '18px',
      'letter-spacing': '0px',
      'line-height': '22px',
      'font-weight': '500',
      display: 'inline-block',
    },
    BodyLargeRegular: {
      'font-family': 'DINOT',
      'font-size': '18px',
      'letter-spacing': '0px',
      'line-height': '28px',
      'font-weight': '400',
      display: 'inline-block',
    },
    BodyMediumBold: {
      'font-family': 'DINOT',
      'font-size': '16px',
      'letter-spacing': '0px',
      'line-height': '22px',
      'font-weight': '700',
      display: 'inline-block',
    },
    BodyMediumRegular: {
      'font-family': 'DINOT',
      'font-size': '16px',
      'letter-spacing': '0px',
      'line-height': '22px',
      'font-weight': '400',
      display: 'inline-block',
    },
    BodySmallBold: {
      'font-family': 'DINOT',
      'font-size': '14px',
      'letter-spacing': '0px',
      'line-height': '18px',
      'font-weight': '700',
      display: 'inline-block',
    },
    BodySmallRegular: {
      'font-family': 'DINOT',
      'font-size': '14px',
      'letter-spacing': '0px',
      'line-height': '18px',
      'font-weight': '400',
      display: 'inline-block',
      'text-overflow': 'ellipsis',
      overflow: 'hidden',
    },
    BodySmallRegularTight: {
      'font-family': 'DINOT',
      'font-size': '16px',
      'letter-spacing': '0px',
      'line-height': '18px',
      'font-weight': '200',
      display: 'inline-block',
    },
    BodyLabel: {
      'font-family': 'DINOT',
      'font-size': '10px',
      'letter-spacing': '0.5px',
      'line-height': '13px',
      'font-weight': '500',
      'text-transform': 'uppercase',
      display: 'inline-block',
    },
    Heading0: {
      'font-family': 'DINOT',
      'font-size': '32px',
      'letter-spacing': '0px',
      'line-height': '36px',
      'font-weight': '700',
      display: 'inline-block',
    },
    Heading1: {
      'font-family': 'DINOT',
      'font-size': '28px',
      'letter-spacing': '0px',
      'line-height': '36px',
      'font-weight': '700',
      display: 'inline-block',
    },
    Heading2: {
      'font-family': 'DINOT',
      'font-size': '24px',
      'letter-spacing': '0px',
      'line-height': '28px',
      'font-weight': '700',
      display: 'inline-block',
    },
    Heading3: {
      'font-family': 'DINOT',
      'font-size': '18px',
      'letter-spacing': '0px',
      'line-height': '24px',
      'font-weight': '700',
      display: 'inline-block',
    },
    Heading4: {
      'font-family': 'DINOT',
      'font-size': '16px',
      'letter-spacing': '0px',
      'line-height': '22px',
      'font-weight': '700',
      display: 'inline-block',
    },
    Label: {
      'font-family': 'DINOT',
      'font-size': '10px',
      'letter-spacing': '1px',
      'line-height': '12px',
      'font-weight': '700',
      'text-transform': 'uppercase',
      display: 'inline-block',
    },
    Link: {
      'font-family': 'DINOT',
      'font-size': '14px',
      'letter-spacing': '0.4px',
      'line-height': '18px',
      'font-weight': '500',
      'text-decoration': 'underline',
      display: 'inline-block',
    },
  },
}

export type GeneratedTheme = typeof theme
